import ajax from '../lib/ajax'
function loadExtlib(id) {
    return ajax.get(`/api/extlib/${id}`).then((resp)=>{
        return resp.result;
    });
}

function loadExtlibByPrefix(prefix) {
    return ajax.get(`/api/extlib/prefix`,{
        params:{prefix}
    }).then((resp)=>{
        return resp.result;
    });
}

function updateExtlib(extlib){
    return ajax.put(`/api/extlib/`,extlib).then((resp)=>{
        return resp.result;
    });
}

function createExtlib(extlib){
    return ajax.post(`/api/extlib`,extlib);
}

function getExtlibs(){
    return ajax.get(`/api/extlib`).then((resp)=>{
        return resp.result;
    });
}

function removeExtlib(id){
    return ajax.delete(`/api/extlib/${id}`).then((resp)=>{
        return resp.result;
    });
}

export { loadExtlib, updateExtlib, createExtlib, getExtlibs, removeExtlib, loadExtlibByPrefix};
